var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true },
        },
      ],
      staticClass: "app-container",
      attrs: { "element-loading-text": "加载中..." },
    },
    [
      _c(
        "el-card",
        {
          staticClass: "sticky-container",
          attrs: { shadow: "never", "body-style": { padding: 0 } },
        },
        [
          _c(
            "template",
            { slot: "header" },
            [
              _c(
                "el-tabs",
                {
                  on: { "tab-click": _vm.handleFilter },
                  model: {
                    value: _vm.queryParams.isOnsale,
                    callback: function ($$v) {
                      _vm.$set(_vm.queryParams, "isOnsale", $$v)
                    },
                    expression: "queryParams.isOnsale",
                  },
                },
                [
                  _c("el-tab-pane", {
                    attrs: { label: "所有商品", name: "-1" },
                  }),
                  _c("el-tab-pane", {
                    attrs: { label: "未审核的商品", name: "0" },
                  }),
                  _c("el-tab-pane", {
                    attrs: { label: "审核通过的商品", name: "1" },
                  }),
                  _c("el-tab-pane", {
                    attrs: { label: "审核失败的商品", name: "2" },
                  }),
                ],
                1
              ),
              _c(
                "el-row",
                { staticClass: "filter-container", attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 6 } },
                    [
                      _c("el-input", {
                        staticClass: "filter-item",
                        attrs: { placeholder: "商品名称" },
                        model: {
                          value: _vm.queryParams.goodsName,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParams, "goodsName", $$v)
                          },
                          expression: "queryParams.goodsName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 6 } },
                    [
                      _c("el-input", {
                        staticClass: "filter-item",
                        attrs: { placeholder: "商家名称" },
                        model: {
                          value: _vm.queryParams.shopName,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParams, "shopName", $$v)
                          },
                          expression: "queryParams.shopName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 12 } },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "filter-item",
                          attrs: { type: "primary", icon: "el-icon-search" },
                          on: { click: _vm.handleFilter },
                        },
                        [_vm._v("查找")]
                      ),
                      _vm.queryParams.storeId
                        ? _c(
                            "el-button",
                            {
                              staticClass: "filter-item",
                              staticStyle: { "margin-left": "10px" },
                              attrs: { type: "danger", icon: "el-icon-edit" },
                              on: { click: _vm.handleCreate },
                            },
                            [_vm._v("增加商品")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                { name: "sticky-header", rawName: "v-sticky-header" },
              ],
              attrs: {
                stripe: "",
                fit: "",
                "highlight-current-row": "",
                data: _vm.list,
                "header-cell-class-name": "table-header-cell",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "序号",
                  width: "60",
                  align: "center",
                  type: "index",
                  "class-name": "table-header-cell",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              scope.$index +
                                1 +
                                (_vm.queryParams.page - 1) *
                                  _vm.queryParams.limit
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "商家名称",
                  prop: "shortName",
                  width: "150",
                  "class-name": "name-col",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "商品名称",
                  prop: "productName",
                  "min-width": "150",
                  "class-name": "name-col",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "商品图片",
                  prop: "cover",
                  width: "100",
                  "class-name": "image-col",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("el-image", {
                          attrs: {
                            src: row.cover,
                            "preview-src-list": [row.cover],
                            lazy: "",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "价格类型", width: "95", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        row.priceType === 2
                          ? _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: "success",
                                  effect: "dark",
                                  size: "medium",
                                },
                              },
                              [_vm._v("现金+积分")]
                            )
                          : row.priceType === 1
                          ? _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: "info",
                                  effect: "dark",
                                  size: "medium",
                                },
                              },
                              [_vm._v("纯积分")]
                            )
                          : _c(
                              "el-tag",
                              { attrs: { effect: "dark", size: "medium" } },
                              [_vm._v("纯现金")]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "零售价",
                  prop: "retailPrice",
                  width: "80",
                  align: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm._v(_vm._s(_vm._f("filterPrice")(row.retailPrice))),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "会员价", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        row.priceType === 0
                          ? _c("div", { staticClass: "space-nowrap" }, [
                              _c("span", [_vm._v("现金：")]),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm._f("filterPrice")(row.retailPrice))
                                ),
                              ]),
                            ])
                          : row.priceType === 2
                          ? _c("div", { staticClass: "mb-5 space-nowrap" }, [
                              _c("span", [_vm._v("现金：")]),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm._f("filterPrice")(row.pointPrice))
                                ),
                              ]),
                            ])
                          : _vm._e(),
                        row.priceType !== 0
                          ? _c("div", { staticClass: "space-nowrap" }, [
                              _c("span", [_vm._v("积分：")]),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm._f("filterPrice")(row.point))
                                ),
                              ]),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "库存",
                  prop: "quantity",
                  width: "80",
                  align: "right",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "上架状态", width: "100", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm._f("saleType")(row.isOnsale),
                              size: "medium",
                            },
                          },
                          [_vm._v(_vm._s(_vm._f("saleText")(row.isOnsale)))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "审核状态", width: "120", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm._f("checkType")(row.status),
                              effect: "dark",
                            },
                          },
                          [_vm._v(_vm._s(_vm._f("checkText")(row.status)))]
                        ),
                        row.status === 2 && row.reason
                          ? _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: row.reason,
                                  placement: "bottom",
                                  effect: "light",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "tool-tip-icon el-icon-warning-outline",
                                }),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", width: "80", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-dropdown",
                          { attrs: { trigger: "click" } },
                          [
                            _c("span", { staticClass: "el-dropdown-link" }, [
                              _vm._v(" 操作"),
                              _c("i", {
                                staticClass:
                                  "el-icon-arrow-down el-icon--right",
                              }),
                            ]),
                            _c(
                              "el-dropdown-menu",
                              { attrs: { slot: "dropdown" }, slot: "dropdown" },
                              [
                                _c(
                                  "el-dropdown-item",
                                  {
                                    attrs: { disabled: row.status !== 0 },
                                    nativeOn: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.handleApprove(row)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "el-icon-check" }),
                                    _vm._v(" 商品审核"),
                                  ]
                                ),
                                _c(
                                  "el-dropdown-item",
                                  {
                                    attrs: {
                                      divided: "",
                                      disabled:
                                        row.isOnsale === 1 || row.status !== 1,
                                    },
                                    nativeOn: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.handleOnsale(row)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "el-icon-upload2" }),
                                    _vm._v(" 商品上架"),
                                  ]
                                ),
                                _c(
                                  "el-dropdown-item",
                                  {
                                    attrs: { disabled: row.isOnsale === 0 },
                                    nativeOn: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.handleDelist(row)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-download",
                                    }),
                                    _vm._v(" 商品下架"),
                                  ]
                                ),
                                _c(
                                  "el-dropdown-item",
                                  {
                                    attrs: { divided: "" },
                                    nativeOn: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.handleEdit(row)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "el-icon-edit" }),
                                    _vm._v(" 编辑商品"),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("pagination", {
            attrs: {
              total: _vm.total,
              page: _vm.queryParams.page,
              limit: _vm.queryParams.limit,
            },
            on: {
              "update:page": function ($event) {
                return _vm.$set(_vm.queryParams, "page", $event)
              },
              "update:limit": function ($event) {
                return _vm.$set(_vm.queryParams, "limit", $event)
              },
              pagination: _vm.fetchData,
            },
          }),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.approveLoading,
              expression: "approveLoading",
            },
          ],
          attrs: {
            title: _vm.dialogTitle,
            width: "80%",
            top: "5vh",
            "destroy-on-close": "",
            "custom-class": "dialog-scrollbar",
            visible: _vm.dialogVisible,
            fullscreen: _vm.device === "mobile",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-right": "10px" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          _vm.dialogVisible = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _vm.isApprove
                    ? _c(
                        "div",
                        [
                          _c(
                            "el-popover",
                            {
                              attrs: { title: "审核不通过", placement: "top" },
                              on: {
                                hide: function ($event) {
                                  _vm.approveMessage = ""
                                },
                              },
                              model: {
                                value: _vm.approveVisible,
                                callback: function ($$v) {
                                  _vm.approveVisible = $$v
                                },
                                expression: "approveVisible",
                              },
                            },
                            [
                              _c(
                                "p",
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入不通过的理由",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.approveMessage,
                                      callback: function ($$v) {
                                        _vm.approveMessage = $$v
                                      },
                                      expression: "approveMessage",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "flex align-center just-end" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text", size: "medium" },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          _vm.approveVisible = false
                                        },
                                      },
                                    },
                                    [_vm._v("取消")]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.onApproved(2)
                                        },
                                      },
                                    },
                                    [_vm._v("确定")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { slot: "reference", type: "info" },
                                  slot: "reference",
                                },
                                [_vm._v("不通过")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-button",
                            {
                              staticStyle: { "margin-left": "10px" },
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.onApproved(1)
                                },
                              },
                            },
                            [_vm._v("审核通过")]
                          ),
                        ],
                        1
                      )
                    : _vm.putOnsale
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.onSale(1)
                            },
                          },
                        },
                        [_vm._v("商品上架")]
                      )
                    : _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.onSale(0)
                            },
                          },
                        },
                        [_vm._v("商品下架")]
                      ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("product-detail", {
            attrs: {
              "store-id": _vm.selectedStoreId,
              "product-id": _vm.selectedGoodsId,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }